import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { change } from 'redux-form';

import { USER_WITH_CARD_ICON } from '@Images';
import { CommonButton } from '@Components';
import { OuterWrapper, Wrapper } from '../styles';
import { getMyInfoPersonalData, getMyInfoRedirectUrl } from '@Redux/actions/my-info';
import { AppDispatch } from '../../../../store.type';
import { getNationality, getSgkycFlowRfiData } from '@Redux/selectors';
import { activateLoader, disableLoader } from '@Redux/actions/ui-trigger';
import {
  changeRfiSgKYCScreen,
  setFlowType,
  toggleLoadPersonalDataSingpass
} from '@Redux/actions/rfi/rfi-action';
import { SG_ODD_FLOW_TYPES, SG_ODD_SCREEN_NAMES } from '../ScreenConstants';
import { FORMNAME_RFI, SG, SINGPASS_CODE } from '@Utils/constants';
import { changeFormField, SINGPASS_ROOT_LANDING_PAGE } from '../utils';

export const SingpassLandingPage: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const sgKycFlowData = useSelector(getSgkycFlowRfiData);
  const radioFieldName = sgKycFlowData?.rfiDetails?.fields_json?.[0]?.field_name || '';
  const rfiId = sgKycFlowData?.rfiDetails?.rfi_id;
  const loadPersonalData = sgKycFlowData?.loadPersonalData;
  const userNationality = useSelector(getNationality);
  const { personal_info_page, address_page } = SG_ODD_SCREEN_NAMES;
  const {
    heading,
    subHeading,
    primaryButtonText,
    secondaryButtonText,
    sub2Description,
    sub2Heading
  } = SINGPASS_ROOT_LANDING_PAGE;

  const fetchMyPersonalInfoData = async () => {
    dispatch(activateLoader());
    const url = new URL(window.location.href);
    const code = url.searchParams.get('code');
    const state = url.searchParams.get('state');
    const error = url.searchParams.get('error');

    if (error) {
      dispatch(disableLoader());
      return;
    }
    dispatch(toggleLoadPersonalDataSingpass(false));
    const response = await dispatch(getMyInfoPersonalData(code, state, null, true));
    if (response?.data?.data?.success) {
      dispatch(setFlowType(SG_ODD_FLOW_TYPES.SINGPASS));
      dispatch(changeRfiSgKYCScreen(address_page));
      dispatch(change(FORMNAME_RFI, radioFieldName, true));
      changeFormField(radioFieldName, 'flow_type', SINGPASS_CODE, dispatch);
    }
    dispatch(disableLoader());
  };

  useEffect(() => {
    if (loadPersonalData) {
      fetchMyPersonalInfoData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadPersonalData]);

  const redirectToSignPass = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    const fetchData = async () => {
      dispatch(activateLoader());
      dispatch(setFlowType(SG_ODD_FLOW_TYPES.SINGPASS));
      await dispatch(getMyInfoRedirectUrl(true, rfiId));
      dispatch(disableLoader());
    };
    fetchData();
  };

  const redirectToManualFlow = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    changeFormField(radioFieldName, 'flow_type', SG_ODD_FLOW_TYPES.NRIC, dispatch);
    dispatch(setFlowType(SG_ODD_FLOW_TYPES.NRIC));
    if (userNationality === SG) {
      changeFormField(radioFieldName, 'is_permanent_sg_resident', true, dispatch);
      changeFormField(radioFieldName, 'is_address_changed', true, dispatch);
    }
    dispatch(changeRfiSgKYCScreen(userNationality === SG ? address_page : personal_info_page));
  };

  return (
    <OuterWrapper>
      <Wrapper>
        <div>
          <img src={USER_WITH_CARD_ICON} alt="User Img" className="userImg" />
        </div>
        <div className="heading">{heading}</div>
        <div className="subHeading">{subHeading}</div>

        <div className="primaryButton">
          <CommonButton text={primaryButtonText} onClick={(e) => redirectToSignPass(e)} />
        </div>
        <div className="sub2Heading">{sub2Heading}</div>
        <div className="optionsDescription"> or</div>
        <div className="seondaryButton">
          <CommonButton
            type="secondary"
            text={secondaryButtonText}
            width={335}
            onClick={(e) => redirectToManualFlow(e)}
          />
        </div>
        <div className="sub2Heading">{sub2Description}</div>
      </Wrapper>
    </OuterWrapper>
  );
};
